<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.12.02</b> - Переработка класса брони!</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Armor Class теперь работает как % снижения урона, а не фиксированное значение</li>
      <li>Удалена стоимость Пыльца пикси за сброс способностей и атрибутов</li>
      <li>Информационная панель Пещеры: добавлены предметы лута в легенду, описание авто-подбора</li>
      <li>Нерф урона Мультивыстрел</li>
      <li>Уменьшены золотые награды за битвы Таверна</li>
      <li>Исправлен баг изменения размера окна игры из Shop</li>
      <li>(И, как обычно, несколько других исправлений багов, не заслуживающих упоминания.)</li>
    </ul>
  </div>
</template>
